import { Set } from 'immutable';

export const GUIDES = 'GUIDES';
export const TRANSFORMATION_BOX = 'TRANSFORMATION_BOX';
export const PIVOT = 'PIVOT';
export const BORDER = 'BORDER';

export default Set([GUIDES, PIVOT, TRANSFORMATION_BOX, BORDER]);
